module.exports = __webpack_public_path__ + "static/media/move_support.e1b75d10.png";